import React from 'react'
import './style.css'

export default function Spacer({ size, className = '', ...props }) {
  return (
    <div
      {...props}
      className={`spacer ${className}`}
      style={{ '--spacing-mobile': `${size[0]}px`, '--spacing-tablet': `${size[1]}px` }}
    />
  )
}

export function AspectSpacer({size, className='', ...props}) {
  return (
    <div
      {...props}
      className={`aspect-spacer ${className}`}
      style={{ 
        '--aspect-spacing-mobile-w': `${size[0][0]}`,
        '--aspect-spacing-mobile-h': `${size[0][1]}`,
        '--aspect-spacing-desktop-w': `${size[1][0]}`,
        '--aspect-spacing-desktop-h': `${size[1][1]}`,
        }}
    >
      <div className='aspect-ratio__inside' />
    </div>
  )
}